// Pastel sage green used as the project accent.
// HSL 150° 38% 40% — soft pastel feel, ~4.0:1 contrast on white in both directions
// (passes WCAG AA-large for the bold hero stat number and for white text on solid bg).
export const ACCENT_PROJECT = '#3D8B68';

// Warm slate used as the academic accent. HSL 217° 15% 43%.
// White-on-fill ~5.5:1 — passes WCAG AA for small text (replaces slate-400 which failed).
// Chromatically distinct from primary (practical) and ACCENT_PROJECT.
export const ACCENT_ACADEMIC = '#5F6B7E';
